var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"image-layout",attrs:{"alt":"Mo's Vehicle Transport","src":require("../../assets/banner.png")},on:{"click":function($event){return _vm.homePage()}}})}
var staticRenderFns = []

export { render, staticRenderFns }